import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as fromApp from '../../store/app.reducers';
import * as fromSetting from '../store/setting.reducers';
import * as SettingActions from '../store/setting.actions';

@Component({
    selector: 'app-subscription-setting',
    templateUrl: './subscription-setting.component.html',
    styleUrls: ['./subscription-setting.component.scss'],
    standalone: false
})
export class SubscriptionSettingComponent implements OnInit {

  settingState: Observable<fromSetting.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.settingState = this.store.select('setting');
    this.store.dispatch(
      new SettingActions.GetSubscriptions({
        params: {}
      })
    );
  }

  onDeleteSubscription(id: number) {
    this.store.dispatch(
      new SettingActions.CancelSubscription({
        id: id
      })
    );
  }

}
